<template>
  <div class="main-content">
    <div
      v-if="table"
      class="table-container"
    >
      <!-- 表头 -->
      <div class="table-header">
        <div
          v-for="(header, index) in table.headers"
          :key="index"
          class="table-header-cell"
        >
          {{ header }}
        </div>
      </div>
      <!-- 表体 -->
      <div class="table-body">
        <div
          v-for="(row, index) in table.value"
          :key="index"
        >
          <div class="table-body-row">
            <div
              v-for="(cell, cellIndex) in row"
              :key="cellIndex"
              class="table-body-cell"
              :ref="`cell-${index}-${cellIndex}`"
            >
              <el-tooltip
                :content="cell"
                placement="bottom"
                effect="light"
                :open-delay="300"
                popper-class="chat-preview-tooltip"
                :disabled="!isCellOverflow(index, cellIndex)"
              >
                <span class="cell-content">{{ cell || '--' }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无数据 -->
    <div class="content-placeholder" v-else>
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductOutput",
  props: {
    previewData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      cellOverflowMap: {}, // 存储每个 cell 是否溢出的状态
    };
  },
  computed: {
    table() {
      if(!this.previewData) {
        return null;
      }
      return this.previewData.table;
    },
  },
  mounted() {
    this.checkCellOverflow();
  },
  updated() {
    this.$nextTick(() => {
      this.checkCellOverflow();
    });
  },
  watch: {
    table: {
      handler() {
        this.$nextTick(() => {
          this.checkCellOverflow();
        });
      },
      deep: true,
    },
  },
  methods: {
    // 检测所有 cell 是否溢出
    checkCellOverflow() {
      if (!this.table || !this.table.value) {
        return;
      }
      
      this.table.value.forEach((row, rowIndex) => {
        row.forEach((cell, cellIndex) => {
          const refKey = `cell-${rowIndex}-${cellIndex}`;
          const refs = this.$refs[refKey];
          const cellElement = Array.isArray(refs) ? refs[0] : refs;
          
          if (cellElement) {
            const spanElement = cellElement.querySelector('.cell-content');
            if (spanElement) {
              // 检测文本是否溢出：scrollWidth > clientWidth 表示溢出
              // 使用 span 元素来检测，因为它包含了实际文本内容
              const isOverflow = spanElement.scrollWidth > spanElement.clientWidth;
              const key = `${rowIndex}-${cellIndex}`;
              this.$set(this.cellOverflowMap, key, isOverflow);
            }
          }
        });
      });
    },
    // 判断指定 cell 是否溢出
    isCellOverflow(rowIndex, cellIndex) {
      const key = `${rowIndex}-${cellIndex}`;
      return this.cellOverflowMap[key] || false;
    },
  },
};
</script>

<style scoped>
.main-content {
  width: 100%;
  height: 100%;
  padding: 8px 12px;
}

.table-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-header {
  width: 100%;
  background-color: rgba(198, 204, 210, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  gap: 10px;
}

.table-header-cell {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: rgba(5, 32, 49, 1);
  flex: 1;
}

.table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* Chrome, Safari, Edge */
  &::-webkit-scrollbar {
    display: none;
  }
}

.table-body-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  gap: 10px;
}

.table-body-cell {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(5, 32, 49, 1);
  flex: 1;
  overflow: hidden;
  text-align: center;
}

.cell-content {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
